import axios from 'axios'
import store from '@/store'

export default {
  getAllUsers () {
    return new Promise((resolve, reject) => {
      axios.post('/api/users-with-trashed', {}, {
        headers: {
          Authorization: 'Bearer' + localStorage.getItem('access_token')
        }
      }).then(({ data }) => {
        store.dispatch('setAllUsers', data)
        resolve(true)
      }, error => {
        reject(error)
      })
    })
  },

  getProjectManagers () {
    return new Promise((resolve, reject) => {
      axios.post('/api/get-project-managers', {}, {
        headers: {
          Authorization: 'Bearer' + localStorage.getItem('access_token')
        }
      }).then(({ data }) => {
        store.dispatch('users/setProjectManagers', data)
        resolve(true)
      }, error => {
        reject(error)
      })
    })
  },

  getAccountManagers () {
    return new Promise((resolve, reject) => {
      axios.post('/api/get-account-managers', {}, {
        headers: {
          Authorization: 'Bearer' + localStorage.getItem('access_token')
        }
      }).then(({ data }) => {
        store.dispatch('users/setAccountManagers', data)
        resolve(data)
      }, error => {
        reject(error)
      })
    })
  },

  restoreUser (userId, data) {
    return new Promise((resolve, reject) => {
      axios.put(`/api/restore/${userId}`, data, {
        headers: {
          Authorization: 'Bearer' + localStorage.getItem('access_token')
        }
      }).then(({ data }) => {
        resolve(data)
      }, error => {
        reject(error)
      })
    })
  },

  deleteUser (userId, data) {
    return new Promise((resolve, reject) => {
      axios.put(`/api/deleted/${userId}`, data, {
        headers: {
          Authorization: 'Bearer' + localStorage.getItem('access_token')
        }
      }).then(({ data }) => {
        resolve(data)
      }, error => {
        reject(error)
      })
    })
  },

  getUnitManagers () {
    return new Promise((resolve, reject) => {
      axios.post('/api/get-unit-managers', {}, {
        headers: {
          Authorization: 'Bearer' + localStorage.getItem('access_token')
        }
      }).then(({ data }) => {
        store.dispatch('users/setUnitManagers', data)
        resolve(true)
      }, error => {
        reject(error)
      })
    })
  },

  getUser (userId) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/user/${userId}`, {
        headers: {
          Authorization: 'Bearer' + localStorage.getItem('access_token')
        }
      }).then(
        res => {
          resolve(res)
        },
        error => {
          reject(error)
        }
      )
    })
  },

  getUserProfile (profileId) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/users/profiles/${profileId}`, {
        headers: {
          Authorization: 'Bearer' + localStorage.getItem('access_token')
        }
      }).then(
        res => {
          resolve(res)
        },
        error => {
          reject(error)
        }
      )
    })
  },

  updateUser (userId, request) {
    return new Promise((resolve, reject) => {
      axios
        .put(`/api/user/update/${userId}`, request, {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then(
          res => {
            resolve(res)
          },
          error => {
            reject(error)
          }
        )
    })
  },

  updateUserProfile (userProfileId, request) {
    return new Promise((resolve, reject) => {
      axios
        .put(`/api/users/profiles/${userProfileId}`, request, {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then(
          res => {
            resolve(res)
          },
          error => {
            reject(error)
          }
        )
    })
  },

  getAllocations () {
    return new Promise((resolve, reject) => {
      axios.get('/api/users/allocations', {
        headers: {
          Authorization: 'Bearer' + localStorage.getItem('access_token')
        }
      }).then((res) => {
        store.dispatch('users/setAllocations', res.data)
        resolve(res)
      }, error => {
        reject(error)
      })
    })
  },

  getAvailability () {
    return new Promise((resolve, reject) => {
      axios.get('/api/users/availability', {
        headers: {
          Authorization: 'Bearer' + localStorage.getItem('access_token')
        }
      }).then((res) => {
        store.dispatch('users/setAvailability', res.data)
        resolve(res)
      }, error => {
        reject(error)
      })
    })
  },

  getEmploymentTypes () {
    return new Promise((resolve, reject) => {
      axios.get('/api/users/employment-types', {
        headers: {
          Authorization: 'Bearer' + localStorage.getItem('access_token')
        }
      }).then((res) => {
        store.dispatch('users/setEmploymentTypes', res.data)
        resolve(res)
      }, error => {
        reject(error)
      })
    })
  },

  getEnglishLevels () {
    return new Promise((resolve, reject) => {
      axios.get('/api/users/english-levels', {
        headers: {
          Authorization: 'Bearer' + localStorage.getItem('access_token')
        }
      }).then((res) => {
        store.dispatch('users/setEnglishLevels', res.data)
        resolve(res)
      }, error => {
        reject(error)
      })
    })
  },

  getPaymentTypes () {
    return new Promise((resolve, reject) => {
      axios.get('/api/users/payment-types', {
        headers: {
          Authorization: 'Bearer' + localStorage.getItem('access_token')
        }
      }).then((res) => {
        store.dispatch('users/setPaymentTypes', res.data)
        resolve(res)
      }, error => {
        reject(error)
      })
    })
  },

  getSeniorityLevels () {
    return new Promise((resolve, reject) => {
      axios.get('/api/users/seniority-levels', {
        headers: {
          Authorization: 'Bearer' + localStorage.getItem('access_token')
        }
      }).then((res) => {
        store.dispatch('users/setSeniorityLevels', res.data)
        resolve(res)
      }, error => {
        reject(error)
      })
    })
  }
}
